import { connect } from "react-redux";

import Rights from "./Rights";

export default connect(state => ({
	rights: state.settings.rights,
	auth: state.user
}))(Rights);
